<div class="bg-gradient-to-br from-white to-gray-50 p-6 rounded-xl shadow-lg border border-gray-100">
  <div class="flex items-center gap-3 mb-6">
    <div class="w-8 h-8 bg-yellow-500 rounded-lg flex items-center justify-center">
      <svg class="w-5 h-5 text-black" fill="currentColor" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clip-rule="evenodd"></path>
      </svg>
    </div>
    <h2 class="text-3xl font-bold text-black tracking-tight">Comentarios</h2>
  </div>
  
  <!-- Skeleton loader durante la carga -->
  @if (isLoading) {
    <div class="space-y-4">
      @for (item of [1, 2, 3, 4, 5]; track $index) {
        <div class="bg-white rounded-xl p-6 border border-gray-200 shadow-sm animate-pulse">
          <ngx-skeleton-loader [theme]="{ height: '40px', width: '200px', 'margin-bottom': '16px', 'border-radius': '8px' }"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ height: '60px', width: '100%', 'margin-bottom': '16px', 'border-radius': '8px' }"></ngx-skeleton-loader>
          <ngx-skeleton-loader [theme]="{ height: '20px', width: '120px', 'margin-bottom': '0px', 'border-radius': '8px' }"></ngx-skeleton-loader>
        </div>
      }
    </div>
  }

  <!-- Mensaje de error -->
  @if (hasError) {
    <div class="text-center p-8 bg-gray-100 border border-gray-300 rounded-xl mt-6">
       <div class="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
         <svg class="w-6 h-6 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
           <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
         </svg>
       </div>
       <p class="text-black font-medium">Ocurrió un error al cargar los comentarios</p>
       <p class="text-gray-600 text-sm mt-1">Por favor, intenta nuevamente más tarde</p>
    </div>
  }

  <!-- Mensaje cuando no hay comentarios -->
  @if (!isLoading && !hasError && comments.length === 0) {
    <div class="text-center p-8 bg-gray-100 border border-gray-300 rounded-xl mt-6">
       <div class="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
         <svg class="w-8 h-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
           <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
         </svg>
       </div>
       <p class="text-black font-medium text-lg">No hay comentarios aún</p>
       <p class="text-gray-600 text-sm mt-1">Sé el primero en dejar un comentario sobre este establecimiento</p>
    </div>
  }

  <!-- Lista de comentarios con contenedor fijo y scrollbar -->
  @if (!isLoading && !hasError && comments.length > 0) {
    <div class="h-96 overflow-y-auto border border-gray-200 rounded-xl bg-gray-50 p-4">
      <div class="space-y-4">
        @for (comment of comments; track comment.id) {
          <div class="bg-white rounded-xl p-6 border border-gray-300 shadow-sm hover:shadow-md transition-all duration-200 hover:border-black">
             <div class="flex justify-between items-start mb-4">
               <div class="flex items-center gap-3">
                 <div class="w-10 h-10 bg-yellow-500 rounded-full flex items-center justify-center">
                   <span class="text-black font-semibold text-sm">{{ comment.ua_name.charAt(0).toUpperCase() }}</span>
                 </div>
                 <div>
                   <h3 class="text-lg font-semibold text-black m-0">{{ comment.ua_name }}</h3>
                   <div class="flex items-center gap-1 mt-1">
                     @for (star of [1,2,3,4,5]; track $index) {
                       <svg class="w-4 h-4" [class]="star <= comment.quantityStart ? 'text-yellow-500 fill-current' : 'text-gray-400'" viewBox="0 0 20 20">
                         <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                       </svg>
                     }
                     <span class="text-sm text-gray-600 ml-2">({{ comment.quantityStart }}/5)</span>
                   </div>
                 </div>
               </div>
             </div>
             <div class="bg-gray-100 rounded-lg p-4 border-l-4 border-yellow-500">
               <p class="text-black leading-relaxed m-0">{{ comment.comment }}</p>
             </div>
          </div>
        }
      </div>
    </div>
    
    <!-- Botón cargar más y información -->
    @if (hasMoreComments || total > 0) {
      <div class="mt-6 text-center">
        <!-- Información de comentarios cargados -->
        <div class="text-sm text-gray-600 mb-4">
          Mostrando {{ comments.length }} de {{ total }} comentarios
        </div>
        
        <!-- Botón cargar más -->
        @if (hasMoreComments) {
          <button 
            (click)="loadMoreComments()"
            [disabled]="isLoadingMore"
            class="px-6 py-3 bg-yellow-500 text-black font-semibold rounded-lg hover:bg-yellow-600 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 mx-auto">
            @if (isLoadingMore) {
              <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Cargando...
            } @else {
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
              Cargar más comentarios
            }
          </button>
        } @else {
          <div class="text-sm text-gray-500 italic">
            No hay más comentarios por cargar
          </div>
        }
      </div>
    }
  }
</div>
